import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Spinner } from '../../../../../design/Spinner';

export const ImportContractLoadingState: React.FC = () => (
  <Stack
    sx={{
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      padding: 3
    }}>
    <Spinner centerPage={false} size={48} />
    <Typography
      variant="body1"
      sx={{
        color: "text.secondary",
        fontWeight: 400,
        fontSize: 14
      }}>
      Reading contract information...
    </Typography>
  </Stack>
);
